export default {
    searchList: {
        searchTxt: [
            {
                'name': '批量选择',
                'value': 'batchQueryValue',
                'type': 'input',
                'unfold': true,
                'placeholder': '最多可查询100单，以逗号隔开',
                'selectConfig': {
                    'name': '批量选择',
                    'prop': 'batchQueryKey',
                    'value': 'customerOrderNo',
                    'option': [
                        { 'label': '客户订单号', 'prop': 'customerOrderNo',placeholder:'最多可查询100单，以逗号隔开' },
                    ],
                },
                'span': 6
            },
            {
                name: '创建时间',
                value: 'importTime',
                type: 'time',
                unfold: true,
                format: 'yyyy-MM-dd HH:mm:ss',
                timeNum: 2,
                span: 6
            },
            {
                name: '客户名称',
                value: 'customerName',
                type: 'advance',
                unfold: true,
                advanceConfig: [
                    { prop: 'ebcuNameCn', value: '客户名称' },
                    { prop: 'pmCode', value: '客户编码' }
                ],
                tableConfig: [
                    { prop: 'pmCode', value: '客户编码' },
                    { prop: 'ebcuNameCn', value: '客户名称' }
                ],
                advanceUrl: '/ebCustomer/searchByEbCustomer',
                cbParams: ['pmCode#customerCode', 'ebcuNameCn#customerName'],
                advanceCode: 'advanceCode',
                span: 4
            },
            {
                name: '模版名称',
                value: 'matchTemplateIdList',
                type: 'select',
                multiple: true,
                filterable: true,
                // unfold: true,
                optionNum: 'MATCH_TEMPLATE_MAP',
                options: [],
                span: 5
            },
            {
                name: '分公司',
                value: 'companyName',
                unfold: true,
                type: 'advance',
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', 'value': '分公司名称' },
                    { prop: 'escoCompanyNo', 'value': '分公司编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNo', 'value': '分公司编码' },
                    { prop: 'escoCompanyNameCn', 'value': '分公司名称' }
                ],
                advanceUrl: '/searchBrand',
                cbParams: ['escoCompanyNameCn#companyName', 'escoCompanyNo#companyCode'],
                span: 3
            },
            {
                name: '服务平台',
                value: 'siteName',
                type: 'advance',
                // unfold: true,
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'branchCompanyNo', value: '分公司编码' },
                    { prop: 'branchCompanyName', value: '分公司名称' }
                ],
                advanceUrl: '/searchPlatform',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                span: 4
            },
            {
                name: '创建人',
                value: 'orderCreateUserCode',
                type: 'input',
                // unfold: true,
                span: 6
            },
            {
                name: '订单来源',
                value: 'orderSourceList',
                type: 'select',
                multiple: true,
                filterable: true,
                // unfold: true,
                optionNum: 'ORDER_SOURCE_FLAG',
                options: [],
                span: 5
            },
            {
                name: '订单状态',
                value: 'orderStatusList',
                type: 'select',
                multiple: true,
                filterable: true,
                unfold: true,
                optionNum: 'ORDER_STATUS_NEW',
                options: [],
                span: 5
            },
            {
                name: '审核状态',
                value: 'excuteStatusList',
                type: 'select',
                multiple: true,
                filterable: true,
                optionNum: 'EXCUTE_STATUS',
                options: [],
                span: 5
            },
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        clickModify: true,
        selectBtn: true,
        leftWidth: 100,
        leftOperation: true,
        columns: [
            {
                label: '客户单号',
                prop: 'customerOrderNo',
                sort: true,
                width: 140,
                align: 'center'
            },
            {
                label: '分公司',
                prop: 'companyName',
                sort: true,
                width: 140,
                align: 'center'
            },
            {
                label: '平台',
                prop: 'siteName',
                sort: true,
                width: 140,
                align: 'center'
            },
            {
                label: '客户',
                prop: 'customerName',
                sort: true,
                width: 140,
                align: 'center'
            },
            {
                label: '模版名称',
                prop: 'matchTemplateId',
                require: true,
                width: 140,
                type: 'select',
                optionNum: 'MATCH_TEMPLATE_MAP',
                options: [],
                sort: true,
                align: 'center'
            },
            {
                'label': '订单状态',
                'prop': 'orderStatusName',
                'width': 110,
                'sort': true
            },
            {
                'label': '审核状态',
                'prop': 'excuteStatusName',
                'width': 110,
                'sort': true
            },
            {
                label: 'AI录单开始时间',
                prop: 'importTime',
                sort: true,
                width: 140,
                align: 'center'
            },
            {
                label: 'AI识别结束时间',
                prop: 'receiveTime',
                sort: true,
                width: 140,
                align: 'center'
            },
            {
                label: 'AI录单结束时间',
                prop: 'uploadedTime',
                sort: true,
                width: 140,
                align: 'center'
            },
            {
                label: 'AI录单识别时长(秒)',
                prop: 'recognizeTimes',
                sort: true,
                width: 160,
                align: 'center'
            },
            {
                label: 'AI录单自动导入时长(秒)',
                prop: 'autoImportTimes',
                sort: true,
                width: 180,
                align: 'center'
            },
            {
                label: 'AI录单总时长(秒)',
                prop: 'totalTimes',
                sort: true,
                width: 140,
                align: 'center'
            },
            {
                label: '业务模式',
                prop: 'businessMode',
                require: true,
                width: 120,
                type: 'select',
                optionNum: 'BUSINESS_MODE',
                options: [],
                sort: true,
                align: 'center'
            },
            {
                label: '订单类型',
                prop: 'orderType',
                require: true,
                width: 120,
                type: 'select',
                optionNum: 'ORDER_TYPE',
                options: [],
                sort: true,
                align: 'center'
            },
            {
                label: '订单来源',
                prop: 'orderSourceName',
                sort: true,
                width: 160,
                align: 'center'
            },
            {
                label: '创建时间',
                prop: 'orderCreateTime',
                sort: true,
                width: 160,
                align: 'center'
            },
            {
                label: '创建人',
                prop: 'orderCreateUserCode',
                sort: true,
                width: 140,
                align: 'center'
            },
        ],
        hasMaxBtnNum: true,
        maxBtnNum: 3,
        action:[]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [
            10,
            20,
            30,
            50,
            100
        ]
    },
    // 高级搜索配置项
    searchTotalTitle: [
    ],
    // 双十一,去掉最近2个月 by曾泓铄
    pickerConfig: {
        shortcuts: [
            { type: 'd', num: 2, text: '最近三天', translate: 'component.E202007300011' },
            { type: 'd', num: 6, text: '最近一周', translate: 'component.E202007300011' },
            { type: 'M', num: 1, text: '最近一个月', translate: 'component.E202007300013' }
        ]
    },
};
